import React from "react";

// Text-based logo: Rajanikant / Machhar — divider — Nishant / Machhar.
// `size` controls the base font size in px; spacing scales with it.
export default function Logo({ size = 11, className = "" }) {
  return (
    <div
      role="img"
      aria-label="Rajanikant Machhar — Nishant Machhar Architects"
      className={`font-body font-medium leading-[1.05] text-center select-none whitespace-nowrap ${className}`}
      style={{ fontSize: `${size}px` }}
    >
      <div>Rajanikant</div>
      <div>Machhar</div>
      <div
        aria-hidden
        className="mx-auto bg-current"
        style={{ width: `${size * 5}px`, height: "1px", margin: "2px auto" }}
      />
      <div>Nishant</div>
      <div>Machhar</div>
    </div>
  );
}
